import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import PromiseUtility from "../../../../utility/promiseUtility";
import ModuleManager from "../../../../framework/core/module_manager";
import DailySignView from "./dailysign_view";
import ActivityUtil from "../activity/activity_util";
import { AutoDialogManager } from "../../../../manager/auto_dialog_manager";

const { ccclass, property } = cc._decorator;
@ccclass
@moduleInit("DailySign")
export default class DailySign extends Module<DailySignView, null>{

    //type: 1精彩活动 2游戏公告
    //showType
    //1活动 2公告 3广告图
    //8添加有礼 9收藏有礼 10邀请排行榜 11三人好友赛 12破产补助 13入群有礼
    _intenData = null
    _datas = null    

    protected m_select_data: any = null

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/dailysign/dailysign";
        this.viewType = DailySignView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = false
        this.needViewBaseTitleBg = false
        this.needViewBaseBg = false
        this.needViewBaseCloseBtn = false
        this.needDeferShow = true
    }

    onInit(intenData){
        this.eventBind('click_dailysign_attach_item', this.on_click_attach_award_btn)
    }

    onDeferShow(intenData) {
        let self = this      
        if(intenData){
            self.m_select_data = null
            let dailyDataMap = intenData.dailyDataMap
                for (let index = 0; index < dailyDataMap.dailyDataList.length; index++) {
                    const dailyData = dailyDataMap.dailyDataList[index];
                    if(index + 1 == dailyDataMap.currentConditionGroup){
                        if(!dailyDataMap.isFinish && dailyDataMap.isReceive){
                            self.m_select_data = dailyData
                        }
                    }
                } 
            self.view.showPanel(intenData)               
            self.show()
            ActivityUtil.refreshModuleOpenTime('DailySign')
        }else{
            this.getDatas(function(dataMap){    
                if(dataMap){
                    self.view.showPanel(dataMap)               
                    self.show()
                    ActivityUtil.refreshModuleOpenTime('DailySign')
                }else{
                    self.hide()
                }
            })
        }        
    }


    protected getDatas(onFinish: Function){
        let self = this
        self.m_select_data = null
        ActivityUtil.getDailySignData(function(dataMap){
            if(dataMap){
                let dailyDataMap = dataMap.dailyDataMap
                for (let index = 0; index < dailyDataMap.dailyDataList.length; index++) {
                    const dailyData = dailyDataMap.dailyDataList[index];
                    if(index + 1 == dailyDataMap.currentConditionGroup){
                        if(!dailyDataMap.isFinish && dailyDataMap.isReceive){
                            self.m_select_data = dailyData
                        }
                    }
                }
            }            
            onFinish && onFinish(dataMap)
        }, self)                  
    }

  

    @bindButtonClickEvent("closeBtn")
    private on_click_close_btn(){
        this.hide()
        AutoDialogManager.openPriorityUI()
    }

    @bindButtonClickEvent("signBtn")
    private on_click_sign_btn(){
        if(this.m_select_data){
            this.on_click_dailysign_btn(this.m_select_data)
        }
    }
    
    private on_click_dailysign_btn(data){
        let self = this
        ActivityUtil.requestDrawActivityAward(data.activityId, function(data){
            self.on_draw_award(data)
        }, function(){

        }, self)     
    }

    private on_click_attach_award_btn(data){
        let self = this
        ActivityUtil.requestDrawActivityAttachAward(data.activityId, function(data){
            self.on_draw_award(data)
        }, function(){

        }, self)     
    }

    private on_draw_award(data){
        let self = this
        self.getDatas(function(dataMap){
            self.view.showPanel(dataMap)
        })
        self.getSelfCurrencyData(null, true)
        let chipNum = 0
        let goldNum = 0
        if(data && data.length > 0){
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if(element.activityAmountType == 5){
                    chipNum += Number(element.amount)
                }else if(element.activityAmountType == 6){
                    goldNum += Number(element.amount)
                }
            }            
            ModuleManager.instance.showModuleName('DialogReceive', {chipNum: chipNum, goldNum: goldNum})
        }
    }

}